__turbopack_context__.v({
  "slide": "index-module-scss-module__H0TVRG__slide",
});
